var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"countdown"},[(!_vm.hideDays && _vm.days > 0)?_c('span',[_vm._v(_vm._s(_vm.days)+" Dias ")]):_vm._e(),_c('span',[_vm._v(_vm._s(_vm.hours))]),_vm._v(":"),_c('span',[_vm._v(_vm._s(_vm.minutes))]),_vm._v(":"),_c('span',[_vm._v(_vm._s(_vm.seconds))])])
}
var staticRenderFns = []

export { render, staticRenderFns }